<template>
  <div>
    <div class="dashboard-hero soft-card">
      <div>
        <div class="hero-kicker">智慧小广管理后台</div>
        <h1>内容维护与服务反馈看板</h1>
        <p>集中查看空置资源、重点企业、用户注册、反馈和专项申请，快速进入常用维护功能。</p>
      </div>
      <div class="hero-badge">广开街道招商服务</div>
    </div>

    <el-row :gutter="20" class="metric-row">
      <el-col :span="6" v-for="item in metrics" :key="item.label">
        <div class="metric-card soft-card" :class="item.type">
          <div class="metric-icon">{{ item.icon }}</div>
          <div class="metric-body">
            <div class="metric-value">{{ item.value }}</div>
            <div class="metric-label">{{ item.label }}</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="14">
        <div class="soft-card panel-card">
          <div class="panel-title">快捷维护</div>
          <div class="quick-grid">
            <div class="quick-card" @click="$router.push('/resources')">
              <i class="el-icon-office-building"></i>
              <b>空置资源管理</b>
              <span>维护资源上下架、排序、图片和联系方式</span>
            </div>
            <div class="quick-card" @click="$router.push('/companies')">
              <i class="el-icon-s-shop"></i>
              <b>重点企业管理</b>
              <span>维护企业展示、地址、电话和导航坐标</span>
            </div>
            <div class="quick-card" @click="$router.push('/feedback')">
              <i class="el-icon-chat-dot-round"></i>
              <b>反馈管理</b>
              <span>查看投诉建议并维护处理状态</span>
            </div>
            <div class="quick-card" @click="$router.push('/special-applications')">
              <i class="el-icon-document"></i>
              <b>专项申请管理</b>
              <span>查看市井烟火活力提升专项申请</span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="10">
        <div class="soft-card panel-card">
          <div class="panel-title">待处理提醒</div>
          <div class="todo-grid">
            <div class="todo-box" :class="{ empty: stats.pendingFeedbackCount === 0 }">
              <div class="todo-num">{{ stats.pendingFeedbackCount }}</div>
              <div class="todo-text">反馈待处理 / 共 {{ stats.feedbackCount }} 条</div>
              <el-button type="primary" size="small" @click="$router.push('/feedback')">查看反馈</el-button>
            </div>
            <div class="todo-box application" :class="{ empty: stats.pendingSpecialApplicationCount === 0 }">
              <div class="todo-num">{{ stats.pendingSpecialApplicationCount }}</div>
              <div class="todo-text">申请待处理 / 共 {{ stats.specialApplicationCount }} 条</div>
              <el-button type="primary" size="small" @click="$router.push('/special-applications')">查看申请</el-button>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { dashboardStats } from '../api'

export default {
  data() {
    return {
      stats: {
        resourceCount: 0,
        companyCount: 0,
        memberCount: 0,
        feedbackCount: 0,
        pendingFeedbackCount: 0,
        specialApplicationCount: 0,
        pendingSpecialApplicationCount: 0
      }
    }
  },
  computed: {
    metrics() {
      return [
        { label: '上架资源', value: this.stats.resourceCount, icon: '楼', type: 'blue' },
        { label: '上架企业', value: this.stats.companyCount, icon: '企', type: 'green' },
        { label: '注册用户', value: this.stats.memberCount, icon: '人', type: 'orange' },
        { label: '反馈总数', value: this.stats.feedbackCount, icon: '信', type: 'purple' },
        { label: '反馈待处理', value: this.stats.pendingFeedbackCount, icon: '待', type: 'red' },
        { label: '专项申请总数', value: this.stats.specialApplicationCount, icon: '申', type: 'teal' },
        { label: '专项申请待处理', value: this.stats.pendingSpecialApplicationCount, icon: '办', type: 'red' }
      ]
    }
  },
  created() {
    dashboardStats({}).then(result => {
      this.stats = Object.assign(this.stats, result || {})
    })
  }
}
</script>

<style scoped>
.dashboard-hero { display: flex; justify-content: space-between; align-items: center; min-height: 150px; padding: 30px 34px; background: linear-gradient(135deg, #f3f9ff 0%, #ffffff 50%, #eef8f5 100%); }
.hero-kicker { color: #2f6f9f; font-weight: 800; margin-bottom: 8px; }
.dashboard-hero h1 { margin: 0 0 10px; font-size: 30px; color: #24364f; }
.dashboard-hero p { margin: 0; color: #718097; }
.hero-badge { padding: 14px 20px; border-radius: 999px; color: #2f6f9f; background: rgba(47, 111, 159, .1); font-weight: 800; }
.metric-row { margin: 22px 0; }
.metric-card { display: flex; align-items: center; gap: 16px; padding: 22px; margin-bottom: 20px; }
.metric-icon { width: 54px; height: 54px; border-radius: 18px; display: flex; align-items: center; justify-content: center; color: #fff; font-weight: 900; font-size: 22px; }
.metric-card.blue .metric-icon { background: #6096c8; }
.metric-card.green .metric-icon { background: #63ae91; }
.metric-card.orange .metric-icon { background: #e3a35d; }
.metric-card.purple .metric-icon { background: #8170b8; }
.metric-card.teal .metric-icon { background: #4ea7a0; }
.metric-card.red .metric-icon { background: #d97882; }
.metric-value { font-size: 30px; font-weight: 900; color: #24364f; }
.metric-label { color: #7a8798; }
.panel-card { padding: 24px; min-height: 300px; }
.panel-title { margin-bottom: 18px; font-size: 18px; font-weight: 900; color: #24364f; }
.quick-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 14px; }
.quick-card { padding: 18px; min-height: 112px; border-radius: 18px; background: #f7faff; cursor: pointer; transition: .2s; }
.quick-card:hover { transform: translateY(-2px); box-shadow: 0 12px 26px rgba(47, 111, 159, .1); }
.quick-card i { color: #2f6f9f; font-size: 24px; }
.quick-card b, .quick-card span { display: block; }
.quick-card b { margin: 12px 0 8px; color: #24364f; }
.quick-card span { color: #7a8798; line-height: 1.5; }
.todo-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 14px; }
.todo-box { min-height: 210px; border-radius: 22px; background: #fff7f5; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 12px; text-align: center; }
.todo-box.application { background: #f4f8ff; }
.todo-box.empty { background: #f2faf6; }
.todo-num { font-size: 48px; font-weight: 900; color: #d97882; }
.todo-box.application .todo-num { color: #6096c8; }
.todo-box.empty .todo-num { color: #63ae91; }
.todo-text { color: #7a8798; font-weight: 700; font-size: 13px; }
</style>
